import React, { useRef, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const InputEdit = (props) => {
  const { label, type, name, value, error, onChange, onBlur, icon, className, style } = props;

  const inputRef = useRef();
  const [textVisible, settextVisible] = useState("password");

  return (
    <div className="input-edit" style={style}>
      <div className={`container ${value ? "active-input" : ""} ${error ? "error-input" : ""} ${className}`}>
        {icon && <i className={icon}></i>}
        <input
          ref={inputRef}
          type={type === "password" ? textVisible : type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {type === "password" &&
          (textVisible === "password" ? (
            <VisibilityIcon fontSize="small" onClick={() => settextVisible("text")} />
          ) : (
            <VisibilityOffIcon fontSize="small" onClick={() => settextVisible("password")} />
          ))}
        <label onClick={() => inputRef.current.focus()} className={value ? "active-label" : ""}>
          {label}
        </label>
      </div>
    </div>
  );
};

export default InputEdit;
